import MSAccountIntegration from "./MSAccountIntegration";

export default MSAccountIntegration;
